import { format } from 'date-fns'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover'
import { COVERAGE_STATUS_LABEL } from '@/modules/projects/components/StatementCoverage/constants'
import { GapEvidence } from '@/modules/projects/components/StatementCoverage/GapEvidence'
import type { MonthlyStatus } from '@/modules/projects/components/StatementCoverage/types'
import type { MapActions } from '@/modules/projects/components/Workbench/mapView'
import { cellClass, cellContent } from './cell'

interface GapCellProps {
  laneLabel: string
  month: MonthlyStatus
  actions: MapActions
}

export const GapCell = ({ laneLabel, month, actions }: GapCellProps) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-drop-target
        className={cellClass(false, month.status)}
        title={`${COVERAGE_STATUS_LABEL[month.status]}. Click to see why.`}
      >
        {cellContent(month.status)}
      </button>
    </PopoverTrigger>
    <PopoverContent className="w-80 p-4">
      <div className="mb-3">
        <div className="text-base font-semibold leading-tight">
          {format(month.date, 'MMMM yyyy')}
        </div>
        <div className="text-xs text-ink-subtle">Account {laneLabel}</div>
      </div>
      <GapEvidence month={month} onOpenStatement={actions.onOpenSegment} />
      {month.status === 'missing' ? (
        <p className="mt-3 border-t pt-3 text-xs text-ink-subtle">
          If the pages are in this project, pick them and drop them here.
        </p>
      ) : null}
    </PopoverContent>
  </Popover>
)
